export const getTopbar = () => {
  return new Promise(resolve => {
    const isTopbarFound =
      window.pnTopbar && Object.keys(window.pnTopbar).length > 0
    const isUnifiedTopbar =
      isTopbarFound && Object.keys(window.pnTopbar).includes('hasLoaded')
    const isOldTopbar = isTopbarFound && !isUnifiedTopbar

    if (isOldTopbar || (isUnifiedTopbar && window.pnTopbar?.hasLoaded)) {
      return resolve(window.pnTopbar)
    }

    // If topbar not found, wait for topbarLoaded event
    window.addEventListener('topbarLoaded', () => {
      resolve(window.pnTopbar)
    })
  })
}
